// TariffCard.styles.ts
import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const TariffCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex: 1;
  padding: ${pxToRem(27)};
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(16)};
  height: ${pxToRem(300)};
  width: 24%;
  box-shadow:
    0px ${pxToRem(9)} ${pxToRem(14.5)} 0px rgba(0, 0, 0, 0.06),
    0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: #ffffff;
`;

export const TariffInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${pxToRem(12)};
  margin-bottom: ${pxToRem(24)};
  text-align: left;
`;

export const TariffExpiration = styled.span`
  color: rgb(185, 185, 185);
  font-size: ${pxToRem(14)};          
  font-weight: 600;
  margin: 0;
`;

export const TariffTitle = styled.h3`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(23)};       
  font-weight: 700;
  margin: 0;
`;

export const TariffDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.mont};
  color: rgb(163, 163, 163);
  font-size: ${pxToRem(18)};
  width: ${pxToRem(280)};
  font-weight: 600;
  margin: 0;
`;

export const TariffPriceContainer = styled.div`
  display: flex;
  align-items: baseline;
`;

export const TariffPrice = styled.div`
  font-size: ${pxToRem(34)};
  font-weight: 700;
  color: rgb(0, 0, 0);
`;

export const PricePeriod = styled.span`
  color: rgb(185, 185, 185);
  font-size: ${pxToRem(20)};
  font-weight: 600;
  margin-left: ${pxToRem(4)};
`;


export const PriceButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(12)};
  justify-content: space-between;
  align-items: start;
  margin-top: auto;
`;